import { BillingInvoiceEditService } from './billing-invoice-edit.service';
import { InvoiceNumberBookPoint } from 'src/app/model/invoice-number-book-point';
import { BillingInvoice } from 'src/app/model/billing/billing-invoice';
import { BillingInvoiceItemEditInfo } from 'src/app/model/billing/billing-invoice-item-edit-info';
import { BillingInvoiceCreateResponse } from 'src/app/model/billing/billing-invoice-create-response';
import { BillingInvoiceEditInfo } from 'src/app/model/billing/billing-invoice-edit-info';
import { ReportViewer } from 'src/app/model/report-viewer';
import { Injectable } from '@angular/core';
import { TaxType } from '../../../enums/tax-type.enum';
import { toFixedTrunc } from '../../../infrastructure/numeric-trunc'; 
import { AliquotTax } from 'src/app/model/aliquot-tax';
import { InvoiceType } from '../../../enums/invoice-type.enum';
import { ClientSearch } from '../../../model/client-search';

@Injectable()
export class BillingInvoiceEntityCreditEditService extends BillingInvoiceEditService {

    billingInvoiceId: number;
    sectorId: number;
    invoiceCompleteNumber: string;

    isVisibleCirculacionAbierta(): boolean {
      return  false;
    }

    isVisibleBillingInvoiceItemManual(): boolean {
      return false;
    }

    isVisibleBillingInvoiceItemEntity(): boolean {
      return false;
    }

    isVisibleDatesFromTo(): boolean {
      return false;
    }

    noDeleteItemManual(): boolean {
      return true;
    }

    isVisibleIsRejectedOptions(): boolean {
      return true;
    }

    isVisibleBillingInvoiceItemEntityCredit(): boolean {
      return true;
    }

    isVisibleBillingInvoiceAssociate(): boolean {
      return false;
    }

    setBillingInvoiceParams(sectorId: number, preBillingId: number, invoiceTypeId: number) {
      throw new Error('Method not implemented.');
    }

    setBillingInvoiceManualParams(sectorId: number,
      invoiceTypeId: number) {
        throw new Error('Method not implemented.');
    }

    setBillingInvoiceCreditParams(sectorId: number, billingInvoiceId: number) {
      this.sectorId = sectorId;
      this.billingInvoiceId = billingInvoiceId;
    }

    async billingInvoiceCreate( clientSearch: ClientSearch,
      invoiceNumberBookPoint: InvoiceNumberBookPoint, billingInvoice: BillingInvoice,
      medicalAppointmentProcedureExcludeIds: number[], items: BillingInvoiceItemEditInfo[]): Promise<BillingInvoiceCreateResponse> {

        return await this.billingInvoiceCreditEntityService.billingInvoiceCreate( 0,
          clientSearch, invoiceNumberBookPoint, billingInvoice,
          medicalAppointmentProcedureExcludeIds, items);
    }

    getInvoiceTypeId(): number {
      return InvoiceType.Credit;
    }

    getParentInvoiceCompleteNumber(): string {
      return this.invoiceCompleteNumber;
    }

    async getBillingInvoiceEditInfo(): Promise<BillingInvoiceEditInfo> {

      const billingInvoiceEditInfo =  await this.billingInvoiceCreditEntityService.
        getBillingInvoiceEditInfo(this.billingInvoiceId, this.sectorId);
      this.invoiceCompleteNumber = billingInvoiceEditInfo.InvoiceCompleteNumber;
      return billingInvoiceEditInfo;

    }

    async getBillingInvoiceReport(billingInvoiceId: number): Promise<ReportViewer> {
      return await this.billingInvoiceEntityService
        .getBillingInvoiceReport(billingInvoiceId);
    }

    async getBillingInvoiceItemEditInfos(): Promise<BillingInvoiceItemEditInfo[]> {
      return await this.billingInvoiceCreditEntityService
        .getBillingInvoiceItems(this.billingInvoiceId);
    }

    async calculateBillingInvoice(billingInvoice: BillingInvoice,
      items: BillingInvoiceItemEditInfo[]): Promise<BillingInvoice> {

       const calculate = await this.billingInvoiceCreditAmountService
        .calculateBillingInvoiceAmount(
          billingInvoice.InvoicePoint,
          items,
          billingInvoice.OriginalIIBBTaxAliquotId,
          billingInvoice.OriginalAmount
        );
        

      billingInvoice.InvoiceTaxes = calculate.InvoiceTaxes;
      billingInvoice.Amount = calculate.Amount;
      billingInvoice.AmountWithTax = calculate.AmountWithTax;

      return billingInvoice;

        
      // return new Promise<BillingInvoice>((resolve, reject) => {
      //   try {

      //     billingInvoice.Amount = 0;
      //     billingInvoice.InvoiceTaxes = [];

      //     items.forEach((item) => {
      //       if (item.AmountDebit) {
      //         billingInvoice.Amount += toFixedTrunc(item.AmountDebit,2);
      //       }
      //     });

      //     this.aliquotTaxService.getAliquotsTax().then(( aliquotsTax ) => {
      //       items.forEach((item) => {
      //         if (item.AmountDebit) {
      //           this.addInvoiceTax(billingInvoice, item); 
      //           if ( this.isIIBBEnbled(billingInvoice) ) {
      //             this.addIIBBTax(billingInvoice, item, aliquotsTax);
      //           }
      //         }
      //       });
      //     });

      //     resolve(billingInvoice);
      //   } catch ( err ) {
      //     reject(err);
      //   }
      // });
    }

  private addInvoiceTax(
    billingInvoice: BillingInvoice,
    item: BillingInvoiceItemEditInfo) {

    let existente = billingInvoice.InvoiceTaxes
      .find(i => i.TaxTypeId === item.AliquotTax.TaxId && i.AliquotId === item.AliquotTax.Id);

    if (!existente) {
      existente = {
        Id: 0,
        Aliquots: [item.AliquotTax.Percentage],
        AliquotId: item.AliquotTax.Id,
        Aliquot: item.AliquotTax.Percentage,
        Amount: 0,
        AmountBase: 0,
        TaxTypeId: item.AliquotTax.TaxId,
        TaxTypeName: 'Iva',
        InvoiceId: 0,
      };
      billingInvoice.InvoiceTaxes.push(existente);
    }

    existente.AmountBase += toFixedTrunc(item.AmountDebit, 2);
    existente.Amount = toFixedTrunc((existente.AmountBase * (existente.Aliquot / 100)), 2);
  }

  private isIIBBEnbled(billingInvoice: BillingInvoice) {
 
    if ( billingInvoice.InvoicePoint.IIBBEnbled &&
        billingInvoice.OriginalIIBBTaxAliquotId ) {
      return billingInvoice.InvoicePoint.IIBBPartialEnbled ||
        billingInvoice.OriginalAmount.toFixed() ===  billingInvoice.Amount.toFixed();
    } else {
      return false;
    }
  }

  private addIIBBTax(billingInvoice: BillingInvoice,
    item: BillingInvoiceItemEditInfo, aliquotsTax: AliquotTax[]) {

      const aliquotTax = aliquotsTax
        .find(a => a.Id === billingInvoice.OriginalIIBBTaxAliquotId);

      let existente = billingInvoice.InvoiceTaxes
        .find(i => i.TaxTypeId === aliquotTax.TaxId && i.AliquotId === aliquotTax.Id);

      if (!existente) {

        existente = {
          Id: 0,
          Aliquots: [ aliquotTax.Percentage ],
          AliquotId: aliquotTax.Id,
          Aliquot: aliquotTax.Percentage,
          Amount: 0,
          AmountBase: 0,
          TaxTypeId: TaxType.IIBB,
          TaxTypeName: 'IIBB',
          InvoiceId: 0,
        };

        billingInvoice.InvoiceTaxes.push(existente);
      }

    existente.AmountBase += toFixedTrunc(item.AmountDebit, 2);
    existente.Amount = toFixedTrunc((existente.AmountBase * (existente.Aliquot / 100)), 2);
  }
}
